/**
 * Authentication (public) route definitions.
 *
 * These routes are accessible without authentication and are typically used
 * for sign-in, password recovery and similar pages. Each route exposes a
 * `meta` object that indicates whether authentication is required and which
 * roles are allowed (empty for public routes).
 *
 * @typedef {Object} AuthRouteMeta
 * @property {boolean} requiresAuth - When false the route is publicly accessible.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route (empty for public routes).
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/signin",
        name: "Signin",
        meta: {
            requiresAuth: false,
            roles: []
        },
        component: () =>
            import(/* webpackChunkName: "auth" */ "@/pages/auth/SignIn")
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        meta: {
            requiresAuth: false,
            roles: []
        },
        component: () =>
            import(
          /* webpackChunkName: "auth" */ "@/pages/auth/ForgotPassword"
            )
    },
    {
        path: "/recover-password",
        name: "RecoverPassword",
        meta: {
            requiresAuth: false,
            roles: []
        },
        component: () =>
            import(
          /* webpackChunkName: "auth" */ "@/pages/auth/RecoverPassword"
            )
    }
]